module.exports = __webpack_public_path__ + "media/images/loader-white-d2b1d248eb4788cb1eca78d1fb9e1541.gif";